import fundSwitchActions from "./fundSwitchActions";

export default fundSwitchActions;
